import EcoImg from 'eco-design/base/eco-img';
import EcoSectionCommon from 'eco-design/elements/eco-section-common';
import EditorLink from 'lowcode/components/EditorLink';
import { useRouter } from 'next/router';
import React, { useState } from 'react';
import { useScrollAnimation } from '../hooks/useScrollAnimation';
import styles from './index.module.scss';
import gtm from '@/utils/gtm';
import { useLang } from '@/app/utils/useLang';

interface ExploreConfig {
    title: string;
    pc: string;
    pad?: string;
    h5: string;
    className?: string;
    list: {
        title: string;
        desc: string;
        btn: string;
        imgUrl?: string;
        url?: string;
    };
}
interface ExploreProps {
    config?: Partial<ExploreConfig>;
}
const Explore: React.FC<ExploreProps> = (props) => {
    const { t } = useLang('Explore');
    const { locale = 'us' } = useRouter();
    const [textEnter, setTextEnter] = useState(false);

    useScrollAnimation({
        triggerSelector: '.page-explore',
        onEnter: () => setTextEnter(true),
    });

    const MoreBtn = () => {
        return (
            <svg width="16" height="17" viewBox="0 0 16 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M6 4.39453L10 8.39453L6 12.3945" stroke="#477BEA" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
            </svg>
        );
    };

    const defaultConfig = {
        title: t('title'),
        pc: 'https://websiteoss.ecoflow.com/figma-uploads/1758083569694-1tvdi8-compressed-%E9%9B%86%E5%90%88kv.jpg',
        pad: 'https://websiteoss.ecoflow.com/figma-uploads/1758083569694-1tvdi8-compressed-%E9%9B%86%E5%90%88kv.jpg',
        h5: 'https://websiteoss.ecoflow.com/figma-uploads/1758083576443-76aw34-compressed-Frame.jpg',
        list: [
            {
                title: t('item1_title'),
                desc: t('item1_desc'),
                btn: t('item1_btn'),
                url: `https://${locale}.ecoflow.com/products/delta-3-classic-portable-power-station`,
                imgUrl: 'https://websiteoss.ecoflow.com/figma-uploads/1757468563105-oi0qtg-compressed-%E4%BA%A7%E5%93%81%E5%9B%BE.png',
            },
            {
                title: t('item2_title'),
                desc: t('item2_desc'),
                btn: t('item2_btn'),
                url: `https://${locale}.ecoflow.com/products/delta-3-ultra-series-portable-power-station`,
                imgUrl: 'https://websiteoss.ecoflow.com/figma-uploads/1758161161754-u66f27-compressed-%E4%BA%A7%E5%93%81%E5%9B%BE.png',
            },
        ],
    };
    const config = { ...defaultConfig, ...props.config };

    const list = config.list;

    console.log(config.list, props.config);

    return (
        <div className={`page-explore ${styles.Explore} ${config.className || ''} GtmModuleData-section`} data-section-id="d3m-explore">
            <div className="eco-content">
                <EcoSectionCommon className={`section-content ${textEnter ? 'enter' : ''}`} title={t('title')} />
                <div className="explore-content">
                    <EcoImg className="img-bg" pc={config.pc} pad={config.pad} h5={config.h5} isOpenLazy={true} />
                    <div className="item-bg">
                        <div className="items-container">
                            {list.map((item: any, index: number) => {
                                return (
                                    <div className="item" key={index}>
                                        <EcoImg
                                            className="item-img"
                                            pc={
                                                item.imgUrl ||
                                                'https://websiteoss.ecoflow.com/figma-uploads/1757468563105-oi0qtg-compressed-%E4%BA%A7%E5%93%81%E5%9B%BE.png'
                                            }
                                            isOpenLazy={true}
                                        />
                                        <div className="item-content">
                                            <div className="item-title">{item.title}</div>
                                            <div className="item-desc">{item.desc}</div>
                                            <EditorLink
                                                className={`item-link GtmModuleData-btn-href item-link-${index + 1}`}
                                                href={item.url}
                                                target="_blank"
                                                dataLayer={{
                                                    event: 'uaEvent',
                                                    event_name: 'buy',
                                                    product_name: item.title,
                                                    position: t('title'),
                                                    __btn_id1: `${styles.Explore} .item-link-${index + 1}`,
                                                    __btn_id2: item.url,
                                                    __btn_type: 'href',
                                                }}
                                            >
                                                <span className="item-link-text">{item.btn}</span>
                                                <MoreBtn />
                                            </EditorLink>
                                        </div>
                                    </div>
                                );
                            })}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Explore;
